module.exports = __webpack_public_path__ + "static/media/inelligent.f5cf7e5e.jpeg";